import React from 'react';

import { Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';

interface EmptyStateProps {
  title?: string | null;
  subTitle?: string | null;
  withSubTitle?: boolean;
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, subTitle, withSubTitle = false }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.wrapper}>
      <Typography variant="h2" component="h2" align="center" className={classes.title}>
        {title ? title : t('page.discover.emptyStateTitle')}
      </Typography>
      {withSubTitle && (
        <p className={classes.subTitle}>
          {subTitle ? subTitle : t('page.discover.emptyStateSubTitle')}
        </p>
      )}
    </Box>
  );
};

export default EmptyState;
